export const QUESTIONS_CONTAINER = "";
export const FAQ_SLICE_CONTAINER = "max-w-[85%] md:max-w-[70%] mx-auto my-28";
export const DESCRIPTION_CONTAINER = "mt-3";
export const PILLS_CONTAINER =
    "max-w-[280px] min-[358px]:max-w-[340px] min-[410px]:max-w-[380px] min-[430px]:max-w-max faq_pill_container flex gap-x-3 md:gap-x-8 mt-4 md:mt-7 overflow-x-auto px-2 py-4";

